import { TARIFFS, SET_SUBTITLE_TEXT, MENU_PAYMENT, CUSTOM_BILLS } from '../constants/pagesConstants'
import {
    API_COMMON_URL,
    CHECK_KEY, SAVE_KEY, ERASE_KEY,
    SAVE_PRODUCT_ID, SAVE_PROMO_CODES,
    SET,
    SUCCESS_STATUS,
    USER_INFO,
} from '../constants/constants';
import { paymentPageTokenSelector, sessionKey } from '../selectors/pagesSelectors';
import { productCurrentProductIdSelector } from '../selectors/productSelector';
import { saveCurrencies, savePeriods } from './filtersAction';
import { saveProducts } from './cartAction';
import { FEATURED_PRODUCTS_PAIR } from '../../constants/constants';
import {
    PROCEED_TO_CHECKOUT_AFTER_AUTH,
    SWITCH_REGISTRATION_FORM_STATE,
    TOGGLE_REGISTRATION_FORM,
    TOKEN_ERROR_LIST,
} from '../constants/checkoutConstants';
import {logout} from "./authActions";


export const getTariffs = (postData) => (dispatch, getState) => {
    let paymentPageToken = paymentPageTokenSelector(getState()) ?? null;
    let userToken = sessionKey(getState()) ?? null;
    const mainProductId = productCurrentProductIdSelector(getState());
    const productsToFetch = [mainProductId, ...FEATURED_PRODUCTS_PAIR[mainProductId]?.products];

    // Quick bug fix https://doboard.com/1/task/37656
    if (!paymentPageToken && !userToken) {
        paymentPageToken = localStorage.getItem('ct_payment_page_token')
    }

    if (!paymentPageToken) {
        userToken = localStorage.getItem('ct_account_key');
    }

    dispatch({
        type: TARIFFS,
        CallAPI: API_COMMON_URL + `?method_name=product_tariffs_get`,
        showTokenError: true,
        postData: {
            ...postData,
            payment_page_token: paymentPageToken,
            user_token: userToken,
            product_ids: productsToFetch.join(','),
            currencies: 1,
        },
    }).then((data) => {
        if (
            data?.apiData?.error_message &&
            TOKEN_ERROR_LIST.includes(data?.apiData?.error_message)
        ) {
            dispatch(logout()).then(() => {
                dispatch(setAccountFormIsVisible(true));
                dispatch(setAccountFormRegisterState(true));
            });
        } else if (data?.apiData?.data?.operation_status === SUCCESS_STATUS) {
            if (data.apiData?.data?.user) {
                dispatch(saveUserInfo({ ...data?.apiData?.data.user }));
            }

            dispatch(
                savePeriods(
                    Object.values(data.apiData.data?.tariffs ?? {}).filter((tariff) => !!tariff?.periods),
                    productCurrentProductIdSelector(getState())
                )
            );

           // console.log( Object.values(data.apiData.data?.products ?? {}))

            dispatch(saveCurrencies(data.apiData.data?.currencies));
            dispatch(
                saveProducts({
                    products: Object.values(data.apiData.data?.products ?? {}),
                    id: getState().pages.productId,
                })
            );

            if(data?.apiData?.data?.promo_codes){
                dispatch(savePromoCodes(data?.apiData?.data?.promo_codes));
            }
        }
    });
};

export const saveUserInfo = (data) => ({
    type: USER_INFO + SET,
    data,
});

export const saveKey = (userToken, paymentPageToken) => {
    if (userToken) {
        localStorage.setItem('ct_account_key', userToken); // #DEPRECATED https://doboard.com/1/task/28527
    }
    if (paymentPageToken) {
        localStorage.setItem('ct_payment_page_token', paymentPageToken);
    }
    return {
        type: SAVE_KEY,
        sessKey: userToken,
        paymentPageToken: paymentPageToken,
    };
};

export const eraseKey = () => {
    localStorage.setItem('ct_account_key', null); // #DEPRECATED https://doboard.com/1/task/28527
    localStorage.setItem('ct_payment_page_token', null);
    return {
        type: ERASE_KEY,
        data: null,
    };
};

export const saveProductId = (value) => (dispatch, getState) => {
    dispatch({
        type: SAVE_PRODUCT_ID,
        productId: value,
    }).then(() => {
       // const params = getCurrentQueryParameters(getState);

       // console.log('params', params)
      //  updateQueryParameters(dispatch, getState, params);
        dispatch(getTariffs());
    });
};

export const checkKey = () => {
    const keyData = localStorage.getItem('ct_account_key'); // string|null
    const sessKey = keyData && (keyData !== 'undefined') && (keyData !== 'null') ? keyData : null; // #DEPRECATED https://doboard.com/1/task/28527
    const tokenData = localStorage.getItem('ct_payment_page_token'); // string|null
    const paymentPageToken = tokenData && (tokenData !== 'undefined') && (tokenData !== 'null') ? tokenData : null;
    return { type: CHECK_KEY, sessKey: sessKey, paymentPageToken: paymentPageToken };
};

export const setAccountFormIsVisible = (flag) => ({
    type: TOGGLE_REGISTRATION_FORM,
    data: flag,
});

export const setProceedToCheckoutAfterAuth = (provider) => ({
    type: PROCEED_TO_CHECKOUT_AFTER_AUTH,
    data: provider,
});

export const setAccountFormRegisterState = (flag) => ({
    type: SWITCH_REGISTRATION_FORM_STATE,
    data: flag,
});

export const setPageSubtitle = (text) => ({
    type: SET_SUBTITLE_TEXT,
    data: text,
});

export const savePromoCodes = (value) => ({
    type: SAVE_PROMO_CODES,
    data: value,
});

export const fetchPaymentMenu = () => (dispatch, getState) => {
    const paymentPageToken = paymentPageTokenSelector(getState()) ?? null;
    const token = sessionKey(getState());

    return new Promise((resolve, reject) => {
        dispatch({
            type: MENU_PAYMENT,
            CallAPI: API_COMMON_URL + '?method_name=product_tariffs_get',
            showTokenError: true,
            postData: {
                user_token: token,
                payment_page_token: paymentPageToken,
                'currencies': 1
            },
        }).then((data) => {
            const apiData = data?.apiData;

            if (
                apiData.error_message &&
                TOKEN_ERROR_LIST.includes(apiData.error_message)
            ) {
                dispatch(logout()).then(() => {
                    dispatch(setAccountFormIsVisible(true));
                    dispatch(setAccountFormRegisterState(true));
                });
            } else if (apiData.data?.operation_status === SUCCESS_STATUS) {

                if (apiData?.data?.user) {
                    dispatch(saveUserInfo({ ...apiData.data.user }))
                }

                if (data.apiData.data?.currencies) {
                    dispatch(saveCurrencies(data.apiData.data?.currencies))
                }

                resolve(apiData.data)
            }
        })
            .catch((error) => {
                reject(error);
            });
    });

};

export const setCustomBills = (data) => (dispatch) => {
    dispatch({
        type: CUSTOM_BILLS,
        data,
    });
}
